module.exports = __webpack_public_path__ + "static/media/edit-icon.b15e4215.svg";